import React from 'react'
import { PopupWidget } from "react-calendly";
import Form from '../components/Form'
import { Helmet } from 'react-helmet-async'

function Equipment() {
  return (

    <>
         <Helmet>
                              <title>Equipment Supplies and Maintenance</title>
                              <meta name="description" content="We offer a wide range of high-quality equipment, ensuring you have the tools needed to get the job done efficiently."/>
                              <link rel="canonical" href="/Equipment"/>
                            </Helmet>

    <div>
          <div className="container-fluid bg-primary py-5 mb-5 hero-header">
    <div className="container py-5">
      <div className="row justify-content-center py-5">
        <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
          <h1 className="display-3 text-white animated slideInDown">
          Equipment Supplies and Maintenance
          </h1>
        </div>
      </div>
    </div>
  </div>
      {/* card Start */}
      <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
   
      <section id="services" class="services">
        <div class="container">
            <h2>Our Services</h2>
            <div class="services-grid">
                <div class="service-card">
                    <i class="fa fa-3x fa-tools service-icon text-primary mb-1"></i>
                
                    <h3>Equipment Repair</h3>
                    <p>Quick and reliable repair services to minimize downtime and maintain productivity.</p>
                </div>
                <div class="service-card">
                    <i class="fa fa-3x fa-cogs service-icon text-primary mb-1"></i>
                    <h3>Preventive Maintenance</h3>
                    <p>Regular maintenance programs to extend the lifespan of your equipment.</p>
                </div>
                <div class="service-card">
                    <i class="fa fa-3x fa-warehouse service-icon text-primary mb-1"></i>
                    <h3>Supplies & Procurement</h3>
                    <p>Comprehensive supply solutions to ensure your business has what it needs, when it needs it.</p>
                </div>
                <div class="service-card">
                    <i class="fa fa-3x fa-shield-alt service-icon text-primary mb-1"></i>
                    <h3>Safety Inspections</h3>
                    <p>Thorough safety checks to ensure your equipment meets industry standards.</p>
                </div>
            </div>
        </div>
    </section>

    <div className="container-xxl py-5">
      <div className="container">
        <div className="row g-5">
        <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
            
            <h1 className="mb-4">
              Welcome to Our<span className="text-primary"> Equipment Supplies and Maintenance Services</span>
            </h1>
            <p className="mb-4">
            We offer a wide range of high-quality equipment, ensuring you have the tools needed to get the job done efficiently.
             Our inventory includes:
            </p>
            
          

           <li><b> Desktop Computers:</b> We supply and maintain high-performance desktop computers from leading manufacturers like Dell, HP, Lenovo, and other top brands to meet your business needs.
           </li>
           <li> <b>Servers:</b> Our server solutions from trusted brands like Dell EMC, HPE, and IBM are designed for reliability, scalability, and optimal performance in enterprise environments. </li>
           <li> <b>Storage:</b> We offer top-tier storage solutions from brands like NetApp, EMC, and HPE, ensuring secure, scalable, and high-performance data management. </li>
           <li><b> Networking Equipment:</b> We provide advanced networking equipment from Cisco, Juniper, and Aruba, enabling seamless, secure, and high-speed connectivity across your organization. </li>
           <li><b> Security Equipment:</b> We supply and maintain state-of-the-art security equipment, including firewalls, surveillance systems, and access control solutions from leading manufacturers like Palo Alto Networks and Axis Communications. </li>
           <li><b> Medical Equipment:</b> We offer a range of medical equipment, including diagnostic and imaging systems from trusted brands such as GE, Siemens, and Philips, ensuring top-quality performance and maintenance.</li>
<br/>
           <h3>Maintenance Solutions</h3>
         
            <p className="mb-4">
            Regular maintenance ensures your equipment operates at peak performance. Our maintenance services include:
            </p>
            <li><b>Preventative Maintenance:</b> Routine checks and servicing to prevent costly breakdowns.</li>
           <li><b> Emergency Repairs:</b> Rapid response to minimize downtime and keep your operations on track.</li>
           <li> <b>Upgrades and Modernization:</b> Enhance the performance of your existing equipment with the latest technology. </li>
           <li><b> Inspection Services:</b> Thorough inspections to ensure compliance with industry standards and regulations.</li>
          </div>
          <div
            className="col-lg-6 wow fadeInUp"
            data-wow-delay="0.1s"
            style={{ minHeight: 400 }}
          >
            <div className="position-relative h-100">
              <img
                className="img-fluid position-absolute w-100 h-100"
                src="https://img.pikbest.com/wp/202352/laptop-illustration-3d-isolated-of-maintenance-on-white-background_9789805.jpg!sw800"
                alt=""
                style={{ objectFit: "cover" }}
              />
            </div>
          </div>
       
        </div>
      </div>
    </div>
    <Form/>
<PopupWidget
                    url="https://calendly.com/nagspros"
                    rootElement={document.getElementById('root')}
                    text="Schedule a Consultation!"
                    textColor="#ffffff"
                    color="#346815FF"
                />
    </div>
    </div>
    </>
  )
}

export default Equipment
